import React from 'react';
import './DateIcon.css';
import { format, addMinutes } from 'date-fns';
import logComponent from '../../common/logComponent';

export default function DateIcon({ size, lightColor, darkColor, date }) {
  if (logComponent('DateIcon')) { console.debug('DateIcon rendered'); }

  let dateObj = new Date(date);
  dateObj = addMinutes(dateObj, dateObj.getTimezoneOffset());

  const sizeToUse = size ? size : '4rem';
    
  return (
    <div 
      className="Date-Icon"
      style={{
        width: sizeToUse,
        height: sizeToUse,
        borderRadius: `calc(${sizeToUse} / 8)`
      }}>
      <div 
        className="Date-Icon__month"
        style={{
          backgroundColor: darkColor ? darkColor : 'black',
          fontSize: `calc(${sizeToUse} / 5)`,
          color: lightColor ? lightColor : 'white',
          borderTopLeftRadius: `calc(${sizeToUse} / 8)`,
          borderTopRightRadius: `calc(${sizeToUse} / 8)`
        }}>
        { format(dateObj, 'MMM') }
      </div>
      <div 
        className="Date-Icon__day"
        style={{
          backgroundColor: lightColor ? lightColor: 'white',
          color: darkColor ? darkColor : 'black',
          fontSize: `calc(${sizeToUse} * 0.6)`,
          borderBottomLeftRadius: `calc(${sizeToUse} / 8)`,
          borderBottomRightRadius: `calc(${sizeToUse} / 8)`,
          borderColor: darkColor ? darkColor : 'black',
          borderWidth: `calc(${sizeToUse} / 12)`
        }}>
          <span>{format(dateObj, 'd')}</span>
      </div>
    </div>
  );
}
